require('./cardReplaceView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ actions
const cardReplaceActions = require('actions/cardReplace');
const printerActions = require('actions/contactCenter/printer');
// @ components
const CardReplaceForm = require('components/cards/cardReplace/cardReplaceForm/cardReplaceForm');
const CardReplaceSuccess = require('components/cards/cardReplace/cardReplaceSuccess/cardReplaceSuccess');
const CardReplaceError = require('components/cards/cardReplace/cardReplaceError/cardReplaceError');
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const WebappRender = require('components/conditionalRender/webappRender')
// @ utilites
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath, recordLinkV2 } = require('utilities/tagging');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { ACTION_EVENT_VIEW, MAESTRO_CARD_EVENT, MAESTRO_NEW_CARD_LINK } = require('constants/tagging');

class CardReplaceView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_REPLACE, { immCard }, history);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/reemplazo', PAGE_GENERIC, '', '', tagging);
        const maestroCard = this.isMaestroNL();
        if(maestroCard){
            const taggingData = {
                categoriaEvento: MAESTRO_NEW_CARD_LINK,
                accionEvento: MAESTRO_CARD_EVENT,
                etiquetaEvento: ACTION_EVENT_VIEW,
                nombrePagina: MAESTRO_NEW_CARD_LINK
            }
            recordLinkV2(taggingData)
         }
    }

    componentWillUnmount() {
        this.props.clearCardReplace();
    }

    isReady() {
        return false;
    }

    handleConfirmLeave() {
        const { resetPrintedIndicators } = this.props
        resetPrintedIndicators();
    }

    isMaestroNL() {
        const { immProfile } = this.props;
        return immProfile.get('originCountry').toUpperCase() === 'NL';
    }

    render() {
        const { match: { params: { cardId } }, immCards, immProfile } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const maestroCard = this.isMaestroNL();
        const tutorial = (
            <TutorialLauncher type={GRAPHIC_TUTOR_TYPE_4} />
        );
        let block = <div></div>;

        if (immCards.get('isFetching')) {
            block = <LoadingSection />;
        } else if (immCard) {
            const { immCardReplace, replaceCard } = this.props;
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cards-replace')
                }
            ];
            const hasError = !!immCardReplace.get('error');
            let blockContent;

            if (immCardReplace.get('success')) {
                blockContent = (
                    <CardReplaceSuccess
                        immCard={immCard}
                        immProfile={immProfile}
                    />
                );
            } else if (hasError) {
                blockContent = (
                    <CardReplaceError
                        immCard={immCard}
                    />
                );
            } else {

                const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
                const cancelText = formatText('wizard-redirectConfirmationCancelButton');
                const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
                const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
                const cardReplaceWizardClassName = contactCenterClassName('col-md-8', 'col-md-12 col-lg-8')
                const cardReplaceSidebarClassName = contactCenterClassName('col-md-4', 'hidden-xs hidden-sm hidden-md col-lg-4')

                blockContent = (
                    <div>
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <WebappRender>
                            <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                <CardDetailsSideBar immCard={immCard} />
                            </div>
                        </WebappRender>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className={cardReplaceWizardClassName}>
                            <PreLeaveModalComponent
                                confirmationMessage={confirmationMessage}
                                confirmationTitle={confirmationTitle}
                                acceptText={acceptText}
                                cancelText={cancelText}
                                isReady={this.isReady}
                                onConfirmLeave={__CONTACT_CENTER__ ? this.handleConfirmLeave : undefined}
                            />
                            <CardReplaceForm
                                immCard={immCard}
                                immCardReplace={immCardReplace}
                                immProfile={immProfile}
                                replaceCard={replaceCard}
                                maestroCard={maestroCard}
                            />
                        </div>
                        {/* >> REF-01 */}
                        <div className={cardReplaceSidebarClassName}>
                            <CardDetailsSideBar immCard={immCard} />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            const cardReplaceBodyClassName = contactCenterClassName('card-replace-view__body', 'grid-view__body')
            const cardReplaceContainerClassName = contactCenterClassName('card-replace-view__container', 'container-fluid')

            block = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle('cardReplace-title')}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={cardReplaceBodyClassName}>
                        <div className={cardReplaceContainerClassName}>
                            <div id="printable-wizard" className="row grid-view--content-position-negative">
                                {blockContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return block;
    }
}

CardReplaceView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardReplace: PropTypes.object.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    replaceCard: PropTypes.func.isRequired,
    clearCardReplace: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired
};

module.exports.constructor = CardReplaceView;
module.exports.CardReplaceView = connect(
    state => ({
        immCards: state.cards,
        immCardReplace: state.cardReplace,
        immProfile: state.profile,
    }), {
    replaceCard: cardReplaceActions.replaceCard,
    resetPrintedIndicators: printerActions.resetPrintedIndicators,
    clearCardReplace: cardReplaceActions.clearCardReplace
})(withRouter(CardReplaceView));
